import { ActionTree } from "vuex/types"
import { NuxtVueI18n } from "nuxt-i18n/types/nuxt-i18n"

import { SitecoreApi } from '~/constants/SitecoreApi'
import { RootState } from "~/store/store.types"
import { getSitecoreLocaleTranslation } from "~/utils/sitecore"

import { EnvironmentState, Language } from "./environment.types"
import { navQuery } from "./queries"

const actions: ActionTree<EnvironmentState, RootState> = {
  setIsWebview ({ commit }, isWebview) {
    commit('SET_WEBVIEW', isWebview)
  },

  setThemeColor ({ commit }, color) {
    commit('SET_THEME_COLOR', color)
  },

  async fetchNav ({ commit }, { locale } = {}) {
    const sc_lang = locale || this.$i18n.locale
    const query = navQuery(sc_lang)

    try {
      const { data: { data } } = await this.$axios.post(SitecoreApi.navigation, { query }, { params: { sc_lang } })

      if (data.header) {
        commit('SET_HEADER', data.header)
      }

      if (data.footer) {
        commit('SET_FOOTER', data.footer)
      }

      if (data.languages && this.$i18n.locales) {
        const languages: Language[] = this.$i18n.locales.map(locale => {
          if (typeof locale === 'object') {
            locale as NuxtVueI18n.Options.LocaleObject
            return {
              ...locale,
              t: getSitecoreLocaleTranslation(locale.iso, data.languages.children)
            }
          }
          return {
            iso: locale,
            t: getSitecoreLocaleTranslation(locale, data.languages.children)
          }
        })

        commit('SET_LANGUAGES', languages)
      }
    } catch (error) {
      console.log('envStore - fetchNav error', error)
    }
  }
}

export default actions
